import router from '@/router/expert';
import { apiClient } from '@/util/resources';

export function isLoggedIn() {
    let userData = getUserData();

    return (userData !== null ? true : false);
}

export function isAdmin() {
    let userData = getUserData();

    return (userData.role === 'ROLE_ADMIN' ? true : false);
}

export function isExpert() {
    let userData = getUserData();

    return (userData.role === 'ROLE_EXPERT' ? true : false);
}

export function getUserData(key) {
    let userData = JSON.parse(sessionStorage.getItem('user'));

    if (typeof key !== 'undefined') {
        return (_.has(userData, key) ? userData[key] : null);
    } else {
        return userData;
    }
}

export function login(context, creds) {
    apiClient.post('api/login', creds).then(response => {
        setUserData(response.data);

        if (_.size(router.currentRoute.query) && router.currentRoute.query.redirect) {
            router.push(router.currentRoute.query.redirect);
        } else {
            router.push({ name: 'appointmentList' });
        }
    }).catch(error => {
        context.$notify({
            group: 'app',
            type: 'error',
            text: error.message,
        });

        context.loginSubmitted = false;
        context.loginButtonText = 'Bejelentkezés';
    });
}

export function logout() {
    apiClient.post('api/logout').then(response => {
        removeUserData();

        router.push({ name: 'login' });
    }).catch(error => {
        removeUserData();

        router.push({ name: 'login' });
    });
}

export function silentLogout() {
    removeUserData();
    router.push({ name: 'login', query: { redirect: router.currentRoute.fullPath } });
}

export function requireNotAuth(to, from, next) {
    if (isLoggedIn()) {
        next({
            path: '/',
        });
    } else {
        next();
    }
}

export function requireAuth(to, from, next) {
    apiClient.get('api/me').then(response => {
        setUserData(response.data);
        next();
    }).catch(error => {
        removeUserData();

        next({
            path: '/login',
            query: { redirect: to.fullPath },
        });
    });
}

function setUserData(user) {
    sessionStorage.setItem('user', JSON.stringify(user));
}

function removeUserData() {
    sessionStorage.clear();
}
